export enum UpgradeItemElementType {
    APPLE = "APPLE",
    ORANGE = "ORANGE",
    STRAWBERRY = "STRAWBERRY"
}
